<template>
  <div class="seach">
    <div class="seach-bg">
      <div class="seach-bg-img">
        <img src="../../assets/searchMb/banner .png" alt="">
      </div>
      <div class="seach-bg-breadcrumb">
        <div class="seach-bg-breadcrumb-cont">
          <div class="seach-bg-breadcrumb-icon">
            <i class="el-icon-search"></i>
          </div>
          <div class="seach-bg-breadcrumb-input">
            <el-input v-model="seachInput" :placeholder="$t('seach.placeholder')"></el-input>
          </div>
          <div class="seach-bg-breadcrumb-btn">
            <div class="seach-bg-breadcrumb-btn-item">
              <button @click="seachQuery">{{ $t('seach.button') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="seach-cont">
      <div class="seach-cont-list">
        <div class="seach-cont-list-item" v-for="(item, index) in seachList" :key="index">
          <div class="seach-cont-list-item-title">
            <strong>{{ item.title }}</strong>
          </div>
          <div class="seach-cont-list-item-content">{{ item.text }}</div>
          <div class="seach-cont-list-item-iconText">
            <div class="seach-cont-list-item-iconText-icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="seach-cont-list-item-iconText-text">{{ item.breadcrumb }}</div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="blogs-news">
      <div class="blogs-news-item" v-for="(item, index) in list" :key="index">
        <div class="item-image">
          <img :src="item.image" alt=""></img>
        </div>
        <div class="item-title">{{ item.title }}</div>
        <div class="item-content">{{ item.content }}</div>
        <div class="item-more-bnt" @click="goDetail(item.id)">更多详情</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList, getNewsDetail } from '@/api/komo';
export default {
  name: 'seach',
  data() {
    return {
      seachInput: '',
      seachList: [
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        },
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        },
        {
          title: this.$t('seach.listTitle'),
          text: this.$t('seach.listText'),
          icon: require('@/assets/seach/book.png'),
          breadcrumb: this.$t('seach.breadcrumb')
        }
      ],
      list: [],
    };
  },
  methods: {
    seachQuery() {
      console.log('seachInput111111', this.seachInput)
      this.getDataList()
    },
    async getDataList() {
      const res = await getNewsList({ type: 'enterprise', search: this.seachInput });
      this.list = res.data?.list;
    },
    async goDetail(id) {
      const res = await getNewsDetail(id);
      if (res.error === 0 && res.data) {
        const list = res.data?.list;
        this.$router.push({
          name: 'detail',
          params: {
            list: list
          }
        });
      }

    }
  },
  created() {
    this.getDataList()
  },
  mounted() {
  }
};
</script>

<style scoped>
/* 样式部分 */
.seach {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}

.seach-bg {
  width: 100%;
  height: 100%;
  position: relative;
  padding-bottom: 2%;
}

.seach-bg-img {
  width: 100%;
  /* height: 580px; */
}

.seach-bg-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.seach-bg-breadcrumb {
  width: 80%;
  height: 10vw;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  border-radius: 20vw;
  position: absolute;
  bottom: -3vw;
  left: 10%;
  z-index: 1
}

.seach-bg-breadcrumb-cont {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12% 0 4%;
}

.seach-bg-breadcrumb-icon {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seach-bg-breadcrumb-icon i {
  font-size: 4vw;
}

.seach-bg-breadcrumb-input {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.seach-bg-breadcrumb-input :deep(.el-input) {
  height: 100%;
}

.seach-bg-breadcrumb-input :deep(.el-input__inner) {
  border: none;
  font-size: 3vw;
  height: 100%;
}

.seach-bg-breadcrumb-btn {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  width: 20vw;
}

.seach-bg-breadcrumb-btn-item {
  width: 93%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4% 0;
}

.seach-bg-breadcrumb-btn-item button {
  border: none;
  width: 100%;
  height: 100%;
  border-radius: 10vw;
  background-color: #1e1e1e;
  box-shadow: 0px 13px 45px 0px rgba(210, 210, 210, 0.5);
  color: #fff;
  font-size: 1rem;
}


/* 内容 */
.seach-cont {
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
}

.seach-cont-list {
  width: 80%;
  height: 100%;
  margin: 0 auto;
}

.seach-cont-list-item {
  padding: 3% 0% 1%;
  border-bottom: 1px solid #95959591;
  display: flex;
  flex-direction: column;
  gap: 1vw;

}

.seach-cont-list-item-title {
  font-size: 5vw;
}

.seach-cont-list-item-content {
  font-size: 3vw;
  color: #1E1E1E;
}

.seach-cont-list-item-iconText {
  display: flex;
  gap: 0.5vw;
  align-items: center;
}

.seach-cont-list-item-iconText-icon {
  width: 3vw;
  height: 3vw;
  display: flex;
}

.seach-cont-list-item-iconText-icon img {
  width: 100%;
  height: 100%;
}

.seach-cont-list-item-iconText-text {
  color: #959595;
  font-size: 3vw;
}

/* BLOGS NEWS */
.blogs-news {
  width: 100%;
  padding: 6% 12px;
}

.blogs-news-item {
  width: 100%;
  background: #FFFFFF;
  padding: 10px;
  border-radius: 20px;
  margin-bottom: 20px;
}

.blogs-news-item:last-child {
  margin-bottom: 0;
  /* 最后一个元素取消 margin */
}

.blogs-news-item .item-image {
  width: 100%;
}

.blogs-news-item .item-image img {
  width: 100%;
}

.blogs-news-item .item-title {
  font-size: 5vw;
  font-weight: bold;
  font-family: MicrosoftYaHei, MicrosoftYaHei;
  line-height: 5vh;
}

.blogs-news-item .item-content {
  font-size: 3vw;
  font-family: MicrosoftYaHei;
  color: #959595;
}

.blogs-news-item .item-more-bnt {
  width: 24vw;
  height: 10vw;
  border-radius: 30px;
  border: 1px solid #979797;
  font-size: 1rem;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #1e1e1e;
  margin: 20px 0 10px 0;
}
</style>